import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const GlobeIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="globe-path"
          d="M21.54 15H17.004C16.47 15 15.958 15.211 15.583 15.586C15.208 15.961 15.004 16.473 15.004 17V21.54M7.004 3.34V5C7.004 5.795 7.32 6.558 7.88 7.121C8.441 7.682 9.204 8 10.004 8C10.531 8 11.036 8.21 11.415 8.586C11.794 8.961 12.004 9.469 12.004 10C12.004 11.1 12.904 12 14.004 12C14.531 12 15.036 11.789 15.415 11.414C15.794 11.039 16.004 10.531 16.004 10C16.004 8.9 16.904 8 18.004 8H21.17M11.004 21.95V18C11.004 17.469 10.795 16.961 10.42 16.586C10.045 16.211 9.531 16 9.004 16C8.477 16 7.963 15.789 7.588 15.414C7.213 15.039 7.004 14.531 7.004 14V13C7.004 12.469 6.795 11.961 6.42 11.586C6.045 11.211 5.531 11 5.004 11H2.05M22.004 12C22.004 17.523 17.527 22 12.004 22C6.481 22 2.004 17.523 2.004 12C2.004 6.477 6.481 2 12.004 2C17.527 2 22.004 6.477 22.004 12Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

GlobeIcon.displayName = "GlobeIcon"

export const GlobeIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="globe-circle"
          d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="globe-section-1"
          d="M15 21.5L19 18.5L20.202 16.5L20.405 15H19.27H17C16.47 15 15.961 15.211 15.586 15.586C15.211 15.961 15 16.47 15 17V21.5Z"
          fill="currentColor"
        />
        <path
          key="globe-section-2"
          d="M21.17 8L17.773 4.844L16.547 4.187L14.594 3.375L11.687 2.75L9.375 2.999L7.75 3.5L7 4V5C7 5.795 7.316 6.558 7.878 7.121C8.441 7.684 9.204 8 10 8C10.531 8 11.039 8.211 11.414 8.586C11.789 8.961 12 9.469 12 10C12 11.1 12.9 12 14 12C14.531 12 15.039 11.789 15.414 11.414C15.789 11.039 16 10.531 16 10C16 8.9 16.9 8 18 8H19.585L21 8L21.17 8Z"
          fill="currentColor"
        />
        <path
          key="globe-section-3"
          d="M2.05 11L4.109 16.484L5.718 18.469L7.437 19.938L9.375 20.877L11 20.962V19.975V18C11 17.469 10.789 16.961 10.414 16.586C10.039 16.211 9.531 16 9 16C8.469 16 7.961 15.789 7.586 15.414C7.211 15.039 7 14.531 7 14V13C7 12.469 6.789 11.961 6.414 11.586C6.039 11.211 5.531 11 5 11C5 11 3.202 11 2.05 11Z"
          fill="currentColor"
        />
        <path
          key="globe-outline"
          d="M15 21.5L19 18.5L20.202 16.5L20.405 15H19.27H17C16.47 15 15.961 15.211 15.586 15.586C15.211 15.961 15 16.47 15 17V21.5M21.17 8L21 8L19.585 8H18C16.9 8 16 8.9 16 10C16 10.531 15.789 11.039 15.414 11.414C15.039 11.789 14.531 12 14 12C12.9 12 12 11.1 12 10C12 9.469 11.789 8.961 11.414 8.586C11.039 8.211 10.531 8 10 8C9.204 8 8.441 7.684 7.878 7.121C7.316 6.558 7 5.795 7 5V4L7.75 3.5L9.375 2.999L11.687 2.75L14.594 3.375L16.547 4.187L17.773 4.844L21.17 8ZM2.05 11C3.202 11 5 11 5 11C5.531 11 6.039 11.211 6.414 11.586C6.789 11.961 7 12.469 7 13V14C7 14.531 7.211 15.039 7.586 15.414C7.961 15.789 8.469 16 9 16C9.531 16 10.039 16.211 10.414 16.586C10.789 16.961 11 17.469 11 18V19.975V20.962L9.375 20.877L7.437 19.938L5.718 18.469L4.109 16.484L2.05 11Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

GlobeIconActive.displayName = "GlobeIconActive"
